export default "__VITE_ASSET__EBwhODrm__"